import { render, staticRenderFns } from "./orderReport.vue?vue&type=template&id=88b39d92&scoped=true&"
import script from "./orderReport.vue?vue&type=script&lang=js&"
export * from "./orderReport.vue?vue&type=script&lang=js&"
import style0 from "./orderReport.vue?vue&type=style&index=0&id=88b39d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b39d92",
  null
  
)

export default component.exports